import { render } from "./edit-subject.vue?vue&type=template&id=bcfada28"
import script from "./edit-subject.vue?vue&type=script&lang=js"
export * from "./edit-subject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__